export default "__VITE_ASSET__aZeTHZxn__"